/**
 * Extends the BlockEmbed video plugin to add the sandbox iframe attribute.
 */
var BlockEmbedExtension = (() => ({
  plugin: md => {
    const originalRenderer = md.renderer.rules.video;
    md.renderer.rules.video = (tokens, idx, options, env, self) => {
      const output = originalRenderer(tokens, idx, options, env, self);
      return output === null || output === void 0 ? void 0 : output.replace('<iframe', '<iframe sandbox="allow-scripts allow-same-origin allow-popups"');
    };
  }
}));

export { BlockEmbedExtension as default };
